import i18n from "@/common/i18n";
const digitsRE = /(\d{3})(?=\d)/g;

export const formatMoney = (value, decimals = 2) => {
  value = parseFloat(value);
  if (!value && value !== 0) return '';
  const stringified = Math.abs(value).toFixed(decimals);
  const $int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
  const i = $int.length % 3;
  const head = i > 0 ? $int.slice(0, i) + ($int.length > 3 ? ',' : '') : '';
  const $float = decimals ? stringified.slice(-1 - decimals) : '';
  const sign = value < 0 ? '-' : '';
  return `${sign}${head}${$int.slice(i).replace(digitsRE, '$1,')}${$float}`;
};
export const formatNum = value => {
  value = parseInt(value);
  let unit = '';
  let k = 99999,
    sizes = ['',
      `${i18n.t("lang.k_022001")}`,
      `${i18n.t("lang.k_022002")}`,
      `${i18n.t("lang.k_022003")}`
    ],
    i;
  if (value > k) {
    i = Math.floor(Math.log(value) / Math.log(k));
    value = (value / Math.pow(k / 10, i)).toFixed(1);
    unit = sizes[i];
  }
  return value + unit;
};

export const liveTag = val => {
  /**
   * webinar_state  1直播 2预约 3结束 4点播 5回放
   * webinar_type  1音频直播 2视频直播 3互动直播 5定时直播 6分组直播
   */
  const liveTypeStr = ['',
    `${i18n.t("lang.k_022004")}`,
    `${i18n.t("lang.k_022005")}`,
    `${i18n.t("lang.k_022006")}`,
    `${i18n.t("lang.k_022007")}`,
    `${i18n.t("lang.k_022008")}`
  ];
  const liveStatusStr = ['',
    `${i18n.t("lang.k_022009")}`,
    `${i18n.t("lang.k_022010")}`,
    `${i18n.t("lang.k_022011")}`,
    '',
    `${i18n.t("lang.k_022012")}`,
    `${i18n.t("lang.k_022013")}`,
    `${i18n.t("lang.k_022014")}`
  ];
  let str = liveTypeStr[val.webinar_state];
  if (val.webinar_state != 4) {
    str += ` | ${liveStatusStr[val.webinar_type]}`;
  }
  // if(val.webinar_show_type==0){
  //   str+=' | 竖屏'
  // }
  return str;
};
export const actionTextTag = val => {
  // webinar_state  1直播 2预约 3结束 4点播 5回放
  // webinar_type  1音频直播 2视频直播 3互动直播 5定时直播
  const liveTypeStr = ['',
    `${i18n.t("lang.k_022004")}`,
    `${i18n.t("lang.k_022005")}`,
    `${i18n.t("lang.k_022006")}`,
    `${i18n.t("lang.k_022007")}`,
    `${i18n.t("lang.k_022008")}`
  ];
  let str = val.webinar_type == 5 ? `${liveTypeStr[val.webinar_state]} | ${i18n.t('lang.k_022015')}` : liveTypeStr[val.webinar_state];
  return str;
};
export const actionTag = val => {
  // console.log(val)
  // webinar_state  1直播 2预约 3结束 4点播 5回放
  // webinar_type  1音频直播 2视频直播 3互动直播 5定时直播
  const liveTypeStr = ['',
    `${i18n.t("lang.k_022004")}`,
    `${i18n.t("lang.k_022005")}`,
    `${i18n.t("lang.k_022006")}`,
    `${i18n.t("lang.k_022007")}`,
    `${i18n.t("lang.k_022008")}`
  ];
  const liveStatusStr = ['',
    `${i18n.t("lang.k_022009")}`,
    `${i18n.t("lang.k_022010")}`,
    `${i18n.t("lang.k_022011")}`,
    '',
    '',
    `${i18n.t("lang.k_022013")}`
  ];
  let str = val.webinar_type == 5 || val.webinar_state == 4 ? `${liveTypeStr[val.webinar_state]}` : liveTypeStr[val.webinar_state] + ' | ' + liveStatusStr[val.webinar_type];
  // if(val.webinar_show_type==0){
  //   str+=' | 竖屏'
  // }
  return str;
};
export const webinarTypeText = val => {
  // console.log(val)
  // webinar_state  1直播 2预约 3结束 4点播 5回放
  // webinar_type  1音频直播 2视频直播 3互动直播 5定时直播
  const liveTypeStr = ['',
    `${i18n.t("lang.k_022009")}`,
    `${i18n.t("lang.k_022010")}`,
    `${i18n.t("lang.k_022011")}`,
    '',
    `${i18n.t("lang.k_022012")}`,
    `${i18n.t("lang.k_022013")}`
  ];
  let str = liveTypeStr[val] ? liveTypeStr[val] + `${i18n.t("lang.k_022004")}` : '';
  return str;
};
export const actionText = val => {
  // webinar_state  1直播 2预约 3结束 4点播 5回放
  const liveTypeStr = ['',
    `${i18n.t("lang.k_022004")}`,
    `${i18n.t("lang.k_022005")}`,
    `${i18n.t("lang.k_022006")}`,
    `${i18n.t("lang.k_022007")}`,
    `${i18n.t("lang.k_022008")}`
  ];
  let str = liveTypeStr[val];
  return str;
};
export const unitTime = val => {
  let str;
  if (val) {
    str = val.substring(0, 16);
  }
  return str || '';
};
export const unitCovert = val => {
  val = Number(val);
  if (isNaN(val)) return 0;
  if (val > 1e5 && val < 1e8) {
    return `${(val / 1e4).toFixed(1)}${i18n.t('lang.k_022001')}`;
  } else if (val > 1e8) {
    return `${(val / 1e8).toFixed(1)}${i18n.t('lang.k_022002')}`;
  } else {
    return val;
  }
};
export const orderTypeText = val => {
  // val  7-结清并发欠费,8-结清流量欠费,10-并发包,11-流量包12-扩展包，13-专业版 ，14回放流量包，15-免费回放流量包，16-并发预充值
  const orderList = [
    `${i18n.t("lang.k_022016")}`,
    `${i18n.t("lang.k_022017")}`,
    '',
    `${i18n.t("lang.k_022018")}`,
    `${i18n.t("lang.k_022019")}`,
    `${i18n.t("lang.k_022020")}`,
    `${i18n.t("lang.k_022021")}`,
    `${i18n.t("lang.k_022022")}`,
    `${i18n.t("lang.k_022023")}`,
    `${i18n.t("lang.k_022024")}`
  ];
  let text = orderList[val - 7];
  return text;
};
export const limitTag = val => {
  // verify  0 免费 1 密码，2 白名单，3 付费活动, 4 邀请码 6.付费+邀请码
  const limitStr = [
    `${i18n.t("lang.k_022025")}`,
    `${i18n.t("lang.k_022026")}`,
    `${i18n.t("lang.k_022027")}`,
    `${i18n.t("lang.k_022028")}`,
    `${i18n.t("lang.k_022029")}`,
    '',
    `${i18n.t("lang.k_022030")}`
  ];
  let str = limitStr[val];
  return str;
};
export const limitText = val => {
  // webinar_state  1直播 2预约 3结束 4点播 5回放
  const liveTypeStr = ['', `${i18n.t("lang.k_022031")}`, `${i18n.t("lang.k_022032")}`, '', '', ''];
  let str = liveTypeStr[val];
  return str;
};
export const liveText = val => {
  // webinar_state  1直播 2预约 3结束 4点播 5回放
  const liveTypeStr = ['',
    `${i18n.t("lang.k_022033")}`,
    `${i18n.t("lang.k_022034")}`,
    `${i18n.t("lang.k_022035")}`,
    `${i18n.t("lang.k_022036")}`,
    `${i18n.t("lang.k_022037")}`
  ];
  let str = liveTypeStr[val];
  return str;
};
//转化电话号码为131****8085
export const filterPhone = value => {
  return String(value).replace(/([0-9]{3})([0-9]{4})([0-9]{4})/, '$1****$3');
};

export const wordStatusCss = ext => {
  ext = ext.toLowerCase();
  if (ext === 'pdf') {
    return 'saasPDFwenjian color-E34522';
  } else if (ext === 'png' || ext === 'jpg' || ext === 'jpeg' || ext === 'bmp') {
    return 'saastupianwenjian color-794CC5';
  } else if (ext === 'video') {
    return 'saasshipinwenjian color-3562FA';
  } else if (ext === 'doc' || ext === 'docx') {
    return 'saaswordwendang color-3562FA';
  } else if (ext === 'ppt' || ext === 'pptx') {
    return 'saaspptwendang color-FA9A32';
  } else if (ext === 'csv') {
    return 'saasCSVwenjian color-14BA6A';
  } else if (ext === 'xls' || ext === 'xlsx') {
    return 'saasexcelwendang color-14BA6A';
  } else if (ext === 'media') {
    return 'saasyinpinwenjian color-3562FA';
  } else if (ext === 'zip') {
    return 'saasyasuowenjian color-676971';
  } else {
    return 'saasexcelwendang color-14BA6A';
  }
};
export const filterSource = value => {
  let arrType = [
    `${i18n.t("lang.k_022038")}`,
    `${i18n.t("lang.k_022039")}`,
    `${i18n.t("lang.k_022040")}`,
    `${i18n.t("lang.k_022041")}`,
    `${i18n.t("lang.k_022042")}`,
    `${i18n.t("lang.k_022043")}`,
    `${i18n.t("lang.k_022044")}`
  ];
  return arrType[value - 5];
};
export const sizeTostr = size => {
  size = Number(size);
  var data = '';
  if (size < 1 * 1024) {
    //如果小于0.1KB转化成B
    data = size.toFixed(1) + 'B';
  } else if (size < 1 * 1024 * 1024) {
    //如果小于0.1MB转化成KB
    data = (size / 1024).toFixed(1) + 'KB';
  } else if (size < 1 * 1024 * 1024 * 1024) {
    //如果小于0.1GB转化成MB
    data = (size / (1024 * 1024)).toFixed(1) + 'M';
  } else {
    //其他转化成GB
    data = (size / (1024 * 1024 * 1024)).toFixed(1) + 'G';
  }
  var sizestr = data + '';
  var len = sizestr.indexOf('.');
  var dec = sizestr.substr(len + 1, 2);
  if (dec == '00') {
    //当小数点后为00时 去掉小数部分
    return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
  }
  return sizestr;
};
export const nicknameFilter = value => {
  let retValue = value;
  if (value && value.length > 8) {
    retValue = value.slice(0, 8) + '...';
  }
  return retValue;
};
//  0.0000 -> 12.00%
export function fmtRateToPercent(num) {
  let rate = 0;
  if (num) {
    rate = (num * 100).toFixed(2); // 保留百分比后的2位小数
  }

  return `${rate}%`;
}

// 日期时间格式化
// 使用例子：
// <el-table-column prop="createdAt" label="时间" width="160">
//   <template slot-scope="scope">
//   <span>{{scope.row.createdAt|dateFormat('YYYY-MM-DD HH:mm:ss')}}</span>
// </template>
// </el-table-column>
export function dateFormat(dt, fmt, defaultValue = '') {
  if (dt) {
    try {
      return dayjs(dt).format(fmt);
    } catch (e) {}
  }
  return defaultValue;
}

/**
 * 格式化分钟
 */
export function formatMinutes(value) {
  let minuteTime = value || 0;
  let hourTime = 0;
  if (value >= 60) {
    hourTime = parseInt(minuteTime / 60);
    minuteTime = parseInt(minuteTime % 60);
  }
  if (hourTime > 0) {
    return `${hourTime}${i18n.t('lang.k_022045')}${minuteTime}${i18n.t('lang.k_022046')}`;
  } else {
    return `${minuteTime}${i18n.t('lang.k_022046')}`;
  }
}